import { render, staticRenderFns } from "./inviteTheDriver.vue?vue&type=template&id=48d83120"
import script from "./inviteTheDriver.vue?vue&type=script&lang=js"
export * from "./inviteTheDriver.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports